import { render } from "./TvmKbbTradeValue.vue?vue&type=template&id=312fabde&scoped=true"
import script from "./TvmKbbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmKbbTradeValue.vue?vue&type=script&lang=js"

import "./TvmKbbTradeValue.vue?vue&type=style&index=0&id=312fabde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312fabde"]])

export default __exports__